import styled from 'styled-components';
import { ReactComponent as RawLabSVG } from '../../../../assets/icons/icon-lab.svg';

export const IconLab = styled(RawLabSVG)``;
